const SWITCH_DESCRIPTION = 'ОПИСАНИЕ'
const SWITCH_PLAYLIST = 'СЛЕДУЮЩИЕ ВИДЕО'
const OPTIONS = [SWITCH_DESCRIPTION, SWITCH_PLAYLIST]

export { SWITCH_DESCRIPTION, SWITCH_PLAYLIST, OPTIONS }
